// Human display labels for internal status VALUES. The STORED value (used in
// logic and queries — e.g. `status IN ('final','legacy-import')`) is never
// changed; this only maps it to friendlier display text. "legacy" is not a
// common word in Indonesia, so the imported runs read "Payroll Lama".
const RUN_STATUS_LABEL = { 'legacy-import': 'Payroll Lama', terbit: 'Terbit (sementara)' };

// runStatusLabel maps a pay-run status to its display text (unknown → as-is).
export function runStatusLabel(status) {
  return RUN_STATUS_LABEL[status] ?? status;
}
